import type { ApiClient, ApiService } from '@/lib/apiClient'
import { toApiError } from '@/lib/vouchApiService/utils'

interface Args {
  userId: string
}

type Response = string

export type JwtValidatorApiService = ApiService<Args, Response>

const createJwtValidatorService =
  (apiClient: ApiClient): JwtValidatorApiService =>
  () =>
    apiClient
      .get(`dashboard/jwt-validator`)
      .then(({ data }) => data)
      .catch(error => Promise.reject(toApiError(error)))

export default createJwtValidatorService
